import React, { useState } from 'react';
import { Row, Column } from './style';
import { Title } from '../../style';

import InputColumn from '../input-column/InputColumn';

const InputRow = ({ changeIndex, activeIndex, inBound, outBound, mobile, metro, changeInBound, changeOutBound, changeMobile, changeMetro }) => {
    return (
        <Row>
            <Column width='100%' margin='0 24px 0 0' mobileMargin='0 4px 0 0'>
                <Title>
                    Average telco minute
                </Title>
                <Row>
                    <InputColumn
                        activeIndex={activeIndex}
                        changeIndex={changeIndex}
                        condition={5}
                        value={inBound}
                        text='Inbound'
                        onBlur={() => {
                            changeInBound(`${inBound}%`);
                            changeIndex(-1);
                        }}
                        changeValue={(value) => {
                            const _value = +value;
                            changeInBound(`${_value}`);
                            changeOutBound(`${100 - _value}%`);
                        }}
                    />
                    <InputColumn
                        activeIndex={activeIndex}
                        changeIndex={changeIndex}
                        condition={6}
                        value={outBound}
                        text='Outbound'
                        onBlur={() => {
                            changeOutBound(`${outBound}%`);
                            changeIndex(-1);
                        }}
                        changeValue={(value) => {
                            const _value = +value;
                            changeOutBound(`${_value}`);
                            changeInBound(`${100 - _value}%`);

                        }}
                    />
                </Row>
            </Column>
            <Column width='100%' margin='0 0 0 24px' mobileMargin='0 0 0 4px'>
                <Title>
                    Outbound %
                </Title>
                <Row>
                    <InputColumn
                        activeIndex={activeIndex}
                        changeIndex={changeIndex}
                        condition={7}
                        value={mobile}
                        text='Mobile'
                        onBlur={() => {
                            changeMobile(`${mobile}%`);
                            changeIndex(-1);
                        }}
                        changeValue={(value) => {
                            const _value = +value;
                            changeMobile(`${_value}`);
                            changeMetro(`${100 - _value}%`)
                        }}
                    />
                    <InputColumn
                        activeIndex={activeIndex}
                        changeIndex={changeIndex}
                        condition={8}
                        value={metro}
                        text='Metro'
                        onBlur={() => {
                            changeMetro(`${metro}%`);
                            changeIndex(-1);
                        }}
                        changeValue={(value) => {
                            const _value = +value;
                            changeMetro(`${_value}`);
                            changeMobile(`${100 - _value}%`);
                        }}
                    />
                </Row>
            </Column>
        </Row>
    );
};

export default InputRow;
